// extracted by mini-css-extract-plugin
module.exports = {"MediaDuration":"MediaDuration_MediaDuration__zymHk"};